export const INSURANCE_TYPE = "insuranceType";
export const DESCRIPTION = "description";
